'use client';

import {
  FeatherAlertTriangle,
  FeatherArrowRight,
  FeatherChevronRight,
  FeatherWand2,
} from '@subframe/core';

import { IconDialog } from './IconDialog';
import {
  acaoCorrigirNomes,
  descricaoProsseguirSemLinhas,
  subtituloInconsistenciaReceita,
  tituloInconsistenciaReceita,
} from '@/shared/utils/inconsistenciaReceita';

interface InconsistenciaReceitaModalProps {
  open: boolean;
  issueCount: number;
  totalCount: number;
  contagemDoLoteInteiro: boolean;
  validCount: number;
  isCorrigindo?: boolean;
  prosseguirDisabled?: boolean;
  onCorrigirTudo: () => void;
  onProsseguirSemLinhas: () => void;
  onRevisarDepois: () => void;
}

export function InconsistenciaReceitaModal({
  open,
  issueCount,
  totalCount,
  contagemDoLoteInteiro,
  isCorrigindo = false,
  prosseguirDisabled = false,
  onCorrigirTudo,
  onProsseguirSemLinhas,
  onRevisarDepois,
}: InconsistenciaReceitaModalProps) {
  return (
    <IconDialog
      open={open}
      tone="warning"
      icon={<FeatherAlertTriangle className="h-[18px] w-[18px]" />}
      title={tituloInconsistenciaReceita(issueCount)}
      description={subtituloInconsistenciaReceita(issueCount, totalCount, contagemDoLoteInteiro)}
      width="w-[480px]"
      onOpenChange={(aberto) => {
        if (!aberto) onRevisarDepois();
      }}
      onFechar={onRevisarDepois}
    >
      <div className="flex flex-col gap-2.5 px-6 pb-6">
        <button
          type="button"
          disabled={isCorrigindo}
          onClick={onCorrigirTudo}
          className="border-brand-100 bg-brand-50 flex w-full cursor-pointer items-center gap-3 rounded-[12px] border border-solid px-4 py-3.5 text-left disabled:opacity-60"
        >
          <div className="bg-brand-100 flex h-9 w-9 flex-none items-center justify-center rounded-full">
            <FeatherWand2 className="text-brand-600 h-4 w-4" />
          </div>
          <div className="flex flex-1 flex-col gap-px">
            <span className="text-body-sm-bold text-default-font">
              {acaoCorrigirNomes(issueCount)}
            </span>
            <span className="text-caption font-caption text-subtext-color">
              Usamos o dado oficial da Receita para essas linhas
            </span>
          </div>
          <FeatherChevronRight className="h-4 w-4 flex-none text-neutral-400" />
        </button>

        <button
          type="button"
          disabled={isCorrigindo || prosseguirDisabled}
          onClick={onProsseguirSemLinhas}
          className="bg-default-background flex w-full cursor-pointer items-center gap-3 rounded-[12px] border border-solid border-neutral-200 px-4 py-3.5 text-left disabled:opacity-60"
        >
          <div className="flex h-9 w-9 flex-none items-center justify-center rounded-full bg-neutral-100">
            <FeatherArrowRight className="h-4 w-4 text-neutral-700" />
          </div>
          <div className="flex flex-1 flex-col gap-px">
            <span className="text-body-sm-bold text-default-font">Prosseguir sem essas linhas</span>
            <span className="text-caption font-caption text-subtext-color">
              {descricaoProsseguirSemLinhas(issueCount)}
            </span>
          </div>
          <FeatherChevronRight className="h-4 w-4 flex-none text-neutral-400" />
        </button>

        <button
          type="button"
          onClick={onRevisarDepois}
          className="text-caption-semibold text-subtext-color w-full cursor-pointer pt-0.5 text-center"
        >
          Revisar manualmente
        </button>
      </div>
    </IconDialog>
  );
}
